import { combineReducers } from "redux";
import getCourseFile from "./get-course-file";
import getUnitFile from "./get-unit-file";
import getComponentFile from "./get-component-file";

const file = combineReducers({
    getCourseFile,
    getUnitFile,
    getComponentFile,
});

export default file;
